module.exports = __webpack_public_path__ + "static/media/KM.7fdeb4b6.svg";